import { Link } from "react-router-dom";
import logo from "@/assets/logo-small.png";

export const Footer = () => {
  return (
    <footer className="bg-muted/30 border-t border-border mt-20 theme-transition">
      <div className="container mx-auto px-4 py-12 theme-transition">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img src={logo} alt="UGC Video Logo" width={48} height={48} className="h-12 w-12 rounded-lg shadow-md transition-all duration-300 hover:scale-110 hover:brightness-110 hover:shadow-lg cursor-pointer" loading="lazy" />
            <span className="text-2xl font-bold gradient-text">
              UGC Video
            </span>
          </div>
          <h2 className="text-xl font-semibold mb-2 text-foreground">
            YAPAY ZEKA DESTEKLİ UGC VİDEO ÜRETİM PLATFORMU
          </h2>
          <p className="text-muted-foreground">
            AI ile profesyonel UGC içerikleri oluşturun
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 max-w-5xl mx-auto mb-8">
          <div>
            <h3 className="font-semibold mb-3">Ürün</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Ana Sayfa
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Fiyatlandırma
                </Link>
              </li>
              <li>
                <Link to="/tiktok-video-olusturucu" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  TikTok Video
                </Link>
              </li>
              <li>
                <Link to="/instagram-reels-yapay-zeka" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Instagram Reels
                </Link>
              </li>
              <li>
                <Link to="/pollo-alternatifi" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Pollo.ai Alternatifi
                </Link>
              </li>
              <li>
                <Link to="/heygen-alternatifi" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  HeyGen Alternatifi
                </Link>
              </li>
              <li>
                <Link to="/capcut-alternatifi" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  CapCut Alternatifi
                </Link>
              </li>
              <li>
                <Link to="/vitrin" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Vitrin — Örnekler
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Hakkımızda
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">UGC Video</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  UGC Video Oluşturucu
                </Link>
              </li>
              <li>
                <Link to="/results" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  UGC Video Örnekleri
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  UGC Video İndirme
                </Link>
              </li>
              <li>
                <Link to="/" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  UGC Video Ücretsiz
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  UGC Video Reklamları
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Kaynaklar</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  SSS
                </Link>
              </li>
              <li>
                <Link to="/help" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Yardım Merkezi
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Destek</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/contact" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  İletişim
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-3">Yasal</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Gizlilik Politikası
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Kullanım Şartları
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Çerez Politikası
                </Link>
              </li>
              <li>
                <Link to="/delivery-return" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Teslimat ve İade
                </Link>
              </li>
              <li>
                <Link to="/distance-sales" className="text-muted-foreground hover:text-primary transition-colors story-link">
                  Mesafeli Satış
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Social Media Icons */}
        <div className="flex items-center justify-center gap-4 mb-6">
          <a 
            href="https://x.com/ugcvideo_tr?s=21" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="X (Twitter)"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
          </a>
          <a 
            href="https://www.tiktok.com/@ugcvideo.tr?_r=1&_t=ZS-91wEQX5G57U" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="TikTok"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z"/>
            </svg>
          </a>
          <a 
            href="https://www.facebook.com/profile.php?id=61584683272356" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="Facebook"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
            </svg>
          </a>
          <a 
            href="https://www.instagram.com/ugcvideo.tr?igsh=MTZpcDJ0NnNzeXo4Zw%3D%3D&utm_source=qr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="Instagram"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
            </svg>
          </a>
          <a 
            href="https://youtube.com/@ugcvideo_tr?si=_XgkKZE4rENXZvAb" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-10 h-10 rounded-full bg-muted flex items-center justify-center hover:bg-primary hover:text-primary-foreground transition-all duration-300"
            aria-label="YouTube"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor">
              <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
            </svg>
          </a>
        </div>

        {/* Payment Icons */}
        <div className="flex items-center justify-center flex-wrap gap-3 mb-8">
          {/* Visa */}
          <div title="Visa" className="h-10 w-16 bg-white rounded-md border flex items-center justify-center shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 16" className="h-5 w-auto" aria-label="Visa">
              <text x="0" y="13" fontFamily="Arial, Helvetica, sans-serif" fontSize="14" fontStyle="italic" fontWeight="900" fill="#1A1F71" letterSpacing="-0.5">VISA</text>
            </svg>
          </div>

          {/* Mastercard */}
          <div title="Mastercard" className="h-10 w-16 bg-white rounded-md border flex items-center justify-center shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 24" className="h-5 w-auto" aria-label="Mastercard">
              <circle cx="15" cy="12" r="9" fill="#EB001B"/>
              <circle cx="25" cy="12" r="9" fill="#F79E1B"/>
              <path d="M20 5.4a9 9 0 0 1 0 13.2 9 9 0 0 1 0-13.2z" fill="#FF5F00"/>
            </svg>
          </div>

          {/* American Express */}
          <div title="American Express" className="h-10 w-16 bg-[#2E77BB] rounded-md border flex items-center justify-center shadow-sm">
            <span className="text-xs font-extrabold text-white tracking-tight leading-none text-center">
              AMERICAN<br/>EXPRESS
            </span>
          </div>

          {/* Troy (Türk kartı) */}
          <div title="Troy" className="h-10 w-16 bg-white rounded-md border flex items-center justify-center shadow-sm gap-0.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00AEEF]"></span>
            <span className="w-1.5 h-1.5 rounded-full bg-[#E30613]"></span>
            <span className="text-xs font-black text-[#1A1F71] tracking-tight ml-0.5">troy</span>
          </div>

          {/* Maestro */}
          <div title="Maestro" className="h-10 w-16 bg-white rounded-md border flex items-center justify-center shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 24" className="h-5 w-auto" aria-label="Maestro">
              <circle cx="15" cy="12" r="9" fill="#0099DF"/>
              <circle cx="25" cy="12" r="9" fill="#ED0006"/>
              <path d="M20 5.4a9 9 0 0 1 0 13.2 9 9 0 0 1 0-13.2z" fill="#6C6BBD"/>
            </svg>
          </div>

          {/* 3D Secure */}
          <div title="3D Secure" className="h-10 px-2 bg-gradient-to-r from-emerald-600 to-emerald-500 rounded-md border border-emerald-400/40 flex items-center justify-center shadow-sm">
            <span className="text-xs font-extrabold text-white tracking-tight">3D SECURE</span>
          </div>
        </div>

        <p className="text-center text-xs text-muted-foreground/70 mb-4">
          Tüm ödemeler SSL şifreleme ile güvence altındadır
        </p>

        <div className="text-center text-sm text-muted-foreground pt-8 border-t border-border">
          <p>© 2024 UGC Video. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  );
};
